import { Injectable } from '@angular/core';
import { HttpUtility } from '@utility/httpUtility';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { VerifyEmail } from '../models/verify-email-model';

@Injectable({ providedIn: 'root' })
export class VerifiedEmailService {
    constructor(private httpUtility: HttpUtility) {}

    getVerifiedEmail(id: string): Observable<VerifyEmail> {
        return this.httpUtility.get<VerifyEmail>(`${environment.apiUrl}/users/verify-email?email=${id}`);
    }
}
